@if (hasPermissionSeybuch) {
  <cap-beschreibung-table-wrapper [tableFullWidth]="tableFullWidth">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "Alpgrundstuecke" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      <cap-list-loader
        [hasRight]="hasPermissionSeybuch && hasRight"
        [listLoader]="listLoader"
        [showTotal]="false"
        [showZeilenSelect]="false">
        <div class="cap-list-loader-content">
          <table class="cap-table-detail">
            <tbody>
              <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
            </tbody>
          </table>
        </div>
      </cap-list-loader>
      <ng-template #tableRows>
        @for (alpgrundstueck of listLoader?.items; track alpgrundstueck) {
          <tr>
            <td>
              <cap-kompakt-grundstueck [capHistinfo]="alpgrundstueck.histInfo" [item]="alpgrundstueck" [navigateTo]="navTargetGrundstuecke">
              </cap-kompakt-grundstueck>
            </td>
          </tr>
        }
      </ng-template>
    </ng-container>
  </cap-beschreibung-table-wrapper>
}
